import { useCheckoutStore } from '../stores/checkoutStore';
import { useGetStructure } from './useGetStructure';
import { useCaptureShoppingCart } from './useCaptureShoppingCart';
import { useGlobalStore } from '../stores/globalStore';
import { useShallow } from 'zustand/shallow';

export const useJourneyOrchestrator = () => {
    const { fetchStructure } = useGetStructure();
    const captureShoppingCart = useCaptureShoppingCart();

    const { shoppingCart } = useGlobalStore(
        useShallow((state) => ({ shoppingCart: state.shoppingCart }))
    );

    const { 
        updateStructure, 
        goToNextStep, 
        setCapturedData, 
        capturedData 
    } = useCheckoutStore();

    const handleStepSubmit = async ({sectionData, goToNextScreenFlag = true} : {sectionData: any, goToNextScreenFlag?: boolean}) => {
        setCapturedData(sectionData);
        const updatedCapturedData = [
            ...capturedData.filter((s) => s.sectionId !== sectionData.sectionId),
            sectionData, 
        ];
        await captureShoppingCart({
            shoppingCart,
            capturedSections: updatedCapturedData,
        });

        const res = await fetchStructure(shoppingCart);

        updateStructure(res.data);
        if(goToNextScreenFlag) {
            goToNextStep();
        }
    };

    return handleStepSubmit ;
};